import { defineDirective } from "../utils/angular";
import { IComponentContext } from "./types";

/** @internal */
export function createComponentHost(): ng.IDirective {

    return defineDirective(ComponentHost, "shared/shell/componentHost.html", {
        components: "=",
        width: "=",
    });

};

/** @internal */
export class ComponentHost {

    static $inject = ["$scope", "$templateCache"];

    constructor(private $scope: ng.IScope, private $templateCache: ng.ITemplateCacheService) {
    }

    $onInit() {

        this.$scope.$watch(() => this.watchComponents(), () => this.update())

    }

    private _components: IComponentContext[]
    private _vm: ComponentViewModel[]

    private width: number;

    get parentScope(): ng.IScope {
        return this.$scope.$parent;
    }

    get components(): IComponentContext[] {
        return this._components
    }

    set components(value: IComponentContext[]) {
        this._components = value
        this.update()
    }

    private watchComponents() {

        if (this._vm) {
            return this._vm.map(i => (i.isVisible() ? i.width : 0).toString()).join(",");
        }

    }

    private update() {

        if (!this.$templateCache) return;

        var prev = this._vm || [];

        const components = this._components || [];

        var vm = components.map(c => {

            var vm = prev.find(v => v.component == c);

            if (!vm) {
                vm = this.createNewComponent(c);
            }

            return vm;

        });

        var fillerIndex = -1;

        vm.forEach((item, index) => {
            if (item.fullWidth) fillerIndex = index;
        });

        vm.forEach((item, index) => {
            item.visible = (index >= fillerIndex);
        });


        var left = 0;

        vm.forEach((item, index) => {

            item.left = left;

            if (index != fillerIndex) {
                if (item.isVisible()) {
                    left += item.width;
                }
            }


        });

        this._vm = vm;
        this.width = (fillerIndex >= 0 ? -1 : left);

    }


    private createNewComponent(c: IComponentContext): ComponentViewModel {

        var templateUrl = this.getTemplateForDirective(c);

        return new ComponentViewModel(c, templateUrl);

    }

    private getTemplateForDirective(c: IComponentContext): string {

        var directive = c.directive;
        var attrs = "";

        if (c.attrs) {
            attrs = Object.getOwnPropertyNames(c.attrs).map(n => n + "='vm.parentScope." + c.attrs[n] + "'").join(" ");
        }

        var url = "/shell/templates/" + directive + ".html";

        if (attrs) {
            url += "/" + attrs;
        }

        var template = this.$templateCache.get(url);

        if (!template) {

            template = "<"
                + directive
                + " " + attrs
                + " component-context='v.component'"
                + "></"
                + directive + ">"

            this.$templateCache.put(url, template);

        }

        return url;

    }

}


class ComponentViewModel {

    left: number;
    visible: boolean = true;

    constructor(public component: IComponentContext, public templateUrl: string) {
    }

    get width(): number {
        return this.component.width;
    }

    get fullWidth(): boolean {
        return (this.component.width == Number.POSITIVE_INFINITY);
    }

    isVisible(): boolean {
        return (this.visible && this.component.visible && this.component.isActive() && (this.component.isPinned));
    }

    getCssStyle(): any {

        var style = {
            position: "absolute",
            top: "40px",
            bottom: "0",
            left: this.left + "px",
        }

        if (this.fullWidth) {
            style["right"] = "0";
        }
        else {
            style["width"] = this.width + "px";
        }

        return style;

    }
}
